import React from 'react';
import { FormControl, InputLabel, MenuItem } from '@material-ui/core';
import MuiSelect from '@material-ui/core/Select';
import { Guid } from 'guid-typescript'

export type SelectItem = {
    name?: string,
    value: string
}
interface IProps {
    onChange: (item: SelectItem) => void;
    selected: SelectItem;
    items: SelectItem[];
    label: string;
    id?: string;
    disabled?: boolean;
    fullWidth?: boolean;
}
export const Select = (props: IProps) => {
    const id = props.id ? props.id : Guid.create().toString();
    return (
        <FormControl fullWidth={props.fullWidth} disabled={props.disabled}>
            <InputLabel id={`${id}_input_label`}>{props.label}</InputLabel>
            <MuiSelect
                fullWidth={props.fullWidth}
                id={id}
                disabled={props.disabled}
                value={props.selected ? props.selected.value : props.selected}
                onChange={e =>{ 
                    let selectedValue = e.target.value;
                    let selected = props.items.find(i => i.value === selectedValue);
                    props.onChange(selected)
                }}
            >
                {props.items.map((i, idx) => <MenuItem key={`${id}_${idx}`} value={i.value}>{i.name}</MenuItem>)}
            </MuiSelect>
        </FormControl>
    )
}